// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5f1da2ec","619":"ee4c8992"}[chunkId] + ".chunk.js";
};